<template>
  <div class="infoBox">
    <div
      style="
        height: 40px;
        display: flex;
        font-size: 18px;
        font-weight: bold;
        align-items: center;
      "
    >
      <div style="margin-right: 10px">
        <el-button type="primary" @click="$router.go(-1)"
          ><i class="el-icon-back" style="margin-right: 10px"></i>
          后退前页</el-button
        >
      </div>
      <div style="color: #000">
        <span
          style="cursor: pointer"
          @click="$router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)"
          >{{ backName || '工作台' }}</span
        >
        <i class="el-icon-arrow-right"></i>
      </div>
      <div style="color: #606266" class="ellipsis">项目信息</div>
    </div>
    <el-row :gutter="24" v-loading="loading">
      <el-col :span="5">
        <el-image
          v-if="disabled"
          fit="contain"
          class="projectImg"
          :src="entity.ProjectImg"
        >
          <div slot="error">
            <div class="image-slot">暂无图片</div>
          </div>
        </el-image>
        <el-upload
          v-else
          class="avatar-uploader"
          :action="
            $rootUrl +
            `/Base_Manage/Upload/ProjectOssUploadFileByForm?UserId=${userInfo.Id}&ProjectId=${entity.Id}`
          "
          :headers="{
            Authorization: token,
          }"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <el-image
            v-if="entity.ProjectImg"
            fit="contain"
            class="projectImg"
            :src="entity.ProjectImg"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
       
      </el-col>
      <el-col :span="17">
        <el-form
          :model="entity"
          :rules="rules"
          ref="entity"
          label-width="120px"
        >
          <el-form-item label="项目编号" prop="Code">
            <div>
              {{ entity.Code }}
            </div>
          </el-form-item>
          <el-form-item label="项目简码" prop="SimplifiedCode">
            <div class="divContent" v-if="disabled">
              {{ entity.SimplifiedCode }}
            </div>
            <el-input v-else v-model="entity.SimplifiedCode"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="Name">
            <div class="divContent" v-if="disabled">
              {{ entity.Name }}
            </div>
            <el-input v-else v-model="entity.Name"></el-input>
          </el-form-item>
          <el-form-item label="项目描述" prop="Describe" class="Describe">
            <div class="divContent" v-if="disabled">
              {{ entity.Describe || '这个家伙很懒，什么也没有留下~' }}
            </div>
            <el-input
              v-else
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="这个家伙很懒，什么也没有留下~"
              v-model="entity.Describe"
              style="font-family: Arial"
            >
            </el-input>
          </el-form-item>
          <el-row :gutter="10">
            <!-- <el-col :span="8">
              <el-form-item label="国家" prop="Country">
                <div class="divContent" v-if="disabled">
                  {{ entity.Country }}
                </div>
                <el-select
                  v-else
                  v-model="entity.Country"
                  filterable
                  placeholder="请选择"
                >
                  <el-option value="中国">中国</el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="所在城市省份" prop="Province">
                <!-- <div class="divContent" v-if="disabled">
                  {{ entity.Province }}{{ entity.City }}
                </div> -->
                <el-select
                  class="flex:1"
                  v-model="entity.Province"
                  placeholder="请选择省"
                  @change="changeProvince"
                  filterable
                >
                  <el-option
                    v-for="item in ProvinceLsit"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在城市市区" prop="City">
                <el-select
                  class="flex:1"
                  v-model="entity.City"
                  placeholder="请选择市"
                  filterable
                >
                  <el-option
                    v-for="item in CityLsit"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="项目类型" prop="ProjectType">
                <div class="divContent" v-if="disabled">
                  {{ entity.ProjectType }}
                </div>
                <el-select v-else v-model="entity.ProjectType" filterable>
                  <el-option
                    v-for="item in ProjectTypeList"
                    :key="item.Id"
                    :label="item.DicName"
                    :value="item.DicName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
              <el-form-item label="项目资料类型" prop="SupplierQualificationsList">
                <div class="divContent" v-if="disabled">
                  {{ entity.SupplierQualificationsList }}
                </div>
                <el-select
                  v-else
                  v-model="entity.SupplierQualificationsList"
                  filterable
                  multiple
                >
                  <el-option
                    v-for="item in SupplierQualificationsList"
                    :key="item.Id"
                    :label="item.DicName"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!--
            <el-col :span="8">
              <el-form-item label="建筑类型" prop="BuildingFormats">
                <div class="divContent" v-if="disabled">
                  {{ entity.BuildingFormats }}
                </div>
                <el-select v-else v-model="entity.BuildingFormats" filterable>
                  <el-option v-for="item in BuildingFormatsList" :key="item.Id" :label="item.DicName"
                    :value="item.DicName"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="项目业态名称" prop="Formats">
                <div class="divContent" v-if="disabled">
                  {{ entity.Formats }}
                </div>
                <el-input v-else v-model="entity.Formats"> </el-input>
              </el-form-item>
            </el-col> -->

            <el-col :span="8">
              <el-form-item label="建筑总面积" prop="TotalArea">
                <div class="divContent" v-if="disabled">
                  <span>{{ entity.TotalArea }}</span>
                  <span class="color">m²</span>
                </div>
                <el-input v-else v-model="entity.TotalArea" type="number">
                  <span slot="suffix">m²</span>
                </el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="地上建筑面积" prop="OnGroundArea">
                <div class="divContent" v-if="disabled">
                  <span>{{ entity.OnGroundArea }}</span>
                  <span class="color">m²</span>
                </div>
                <el-input v-else v-model="entity.OnGroundArea" type="number">
                  <span slot="suffix">m²</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地下建筑面积" prop="UnderGroundArea">
                <div class="divContent" v-if="disabled">
                  <span>{{ entity.UnderGroundArea }}</span>
                  <span class="color">m²</span>
                </div>
                <el-input v-else v-model="entity.UnderGroundArea" type="number">
                  <span slot="suffix">m²</span>
                </el-input>
              </el-form-item>
            </el-col> -->

            <el-col :span="8">
              <el-form-item label="开工时间" prop="OpeningTime">
                <div class="divContent" v-if="disabled">
                  <span>{{
                    entity.OpeningTime
                      ? entity.OpeningTime.substring(0, 10)
                      : ''
                  }}</span>
                </div>
                <el-date-picker
                  v-else
                  v-model="entity.OpeningTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="计划完工" prop="PlannedCompletionDate">
                <div class="divContent" v-if="disabled">
                  <span>{{
                    entity.PlannedCompletionDate
                      ? entity.PlannedCompletionDate.substring(0, 10)
                      : ''
                  }}</span>
                </div>
                <el-date-picker
                  v-else
                  v-model="entity.PlannedCompletionDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="计划移交时间" prop="HandoverTime">
                <div class="divContent" v-if="disabled">
                  <span>{{
                    entity.HandoverTime
                      ? entity.HandoverTime.substring(0, 10)
                      : ''
                  }}</span>
                </div>
                <el-date-picker
                  v-else
                  v-model="entity.HandoverTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="项目经理" prop="ProjectManagerId">
                <el-select v-model="entity.ProjectManagerId" filterable>
                  <el-option
                    v-for="item in UserList"
                    :key="item.Id"
                    :label="
                      item.NickName
                        ? `${item.NickName}(${item.Phone})`
                        : item.Name
                        ? `${item.Name}(${item.Phone})`
                        : item.Phone
                    "
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物业单位" prop="Property_Company">
                <div style="overflow: hidden">
                  <el-input
                    v-model="entity.Property_Company"
                    disabled
                    style="width: calc(100% - 60px)"
                  >
                    <!-- <span >m²</span> -->
                  </el-input>
                  <el-button
                    type="primary"
                    size="mini"
                    style="width: 60px"
                    @click="openDialog"
                    >选择</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建设单位" prop="ConstructionUnit">
                <el-input v-model="entity.ConstructionUnit"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建设单位联系人" prop="TotalArea">
                <el-input v-model="entity.ConstructionManager"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建设单位手机号" prop="TotalArea">
                <el-input v-model="entity.ConstructionPhone"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <!-- <div>
          <el-button size="mini" type="primary" v-if="disabled" @click="edit">维护资料</el-button>
        </div> -->

        <div>
          <el-button
            size="mini"
            type="primary"
            @click="save"
            :disabled="changeNum <= 1"
            >保 存</el-button
          >
        </div>
        <!-- <div style="margin-top: 20px">
          <el-button size="mini" type="primary" @click="openDesIgn">设计模板</el-button>
        </div> -->
        <!-- <div v-if="!disabled" style="margin-top: 10px">
          <el-button size="mini" @click="cancelEdit">取 消</el-button>
        </div> -->
      </el-col>
    </el-row>
    <el-row>
      <lou-don />
    </el-row>
    <PMCSelect ref="PMCSelect" @select="dialogContact" type="radio" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Token from '@/utils/cache/TokenCache.js'
import LouDon from './LouDonForm.vue'
import PMCSelect from '@/components/PMCSelect.vue'
import { Loading } from 'element-ui'
export default {
  components: {
    LouDon,
    PMCSelect,
  },
  data() {
    return {
      backName: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      loading: false,
      entity: {},
      rules: {},
      visible: false,
      token: '',
      ProvinceLsit: [],
      CityLsit: [],
      UserList: [],
      disabled: false,
      ProjectTypeList: [],
      BuildingFormatsList: [],
      ClimaticZoneList: [],
      SupplierQualificationsList: [],
      changeNum: 0,
    }
  },
  async created() {
    this.token = 'Bearer ' + Token.getToken()
    this.backName = window.localStorage.getItem('ProjectName') || ''
    await this.getProvince()
    await this.getUserList()
    this.getProjectInfo()
    this.getSelectList()
    // this.getProjectTypeList();
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {

    getProjectTypeList() {},
    openDesIgn(a) {
      console.log(this.entity)

      this.$router.push('/DesignPattern?Id=' + this.entity.Id)
    },
    edit() {
      this.entity = JSON.parse(JSON.stringify(this.entity))
      // this.disabled = false;
    },
    cancelEdit() {
      this.getProjectInfo()
      // this.disabled = true;
    },
    openDialog(text) {
      let str = typeof text == 'string' ? text : ''
      this.$refs.PMCSelect.open(str)
    },
    dialogContact(arr) {
      console.log(arr)
      this.$set(this.entity, 'PMCId', arr[0].Id)
      this.$set(this.entity, 'Property_Company', arr[0].PMC_Name)
      this.$set(this.entity, 'Property_Manager', arr[0].PMC_Person)
      this.$set(this.entity, 'Contact_Phone', arr[0].PMC_Phone)
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file)
      if (res.code == 200) {
        this.entity.Project_Photo_Url = res.url
        this.entity.ProjectImg = res.url
      } else {
        this.$notify.error(res.Msg)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    // 下拉
    getSelectList() {
      let arr = ['ProjectType', 'SupplierQualifications']
      arr.forEach((item) => {
        this.$http
          .post(
            '/Base_ProjectManage/Project_DictionaryMain/GetTheDataByDicKey',
            {
              Condition: 'DicKey',
              Keyword: item,
            }
          )
          .then((res) => {
            if (res.Success)
              this[item + 'List'] = res.Data.DictionaryDetailsList
          })
      })
    },
    // 更换省份
    changeProvince(e) {
      this.$set(this.entity, 'City', '')
      console.log(e)
      let id = this.ProvinceLsit.find((item) => item.Name == e).Id
      this.getCityLsit(id)
    },
    // 获取用户信息
    async getUserList() {
      await this.$http
        .post('/Base_Manage/Base_VIPUserInfo/GetDataList', {})
        .then((res) => {
          this.UserList = res.Data
        })
    },
    // 获取省份信息
    async getProvince() {
      await this.$http
        .post('/Base_BasicData/Base_District/GetDistrictList')
        .then((res) => {
          this.ProvinceLsit = res.Data
        })
    },
    // 获取市/区信息
    async getCityLsit(pid) {
      await this.$http
        .post('/Base_BasicData/Base_District/GetDistrictList?ParentId=' + pid)
        .then((res) => {
          this.CityLsit = res.Data
        })
    },
    // 项目基本信息
    getProjectInfo() {
      this.loading = true
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetTheData', {
          id: this.$route.query.id,
        })
        .then(async (res) => {
          this.loading = false
          if (res.Success) {
            this.entity = res.Data
            if (this.entity.Province) {
              let id = this.ProvinceLsit.find(
                (item) => item.Name == this.entity.Province
              ).Id
              if (id) {
                await this.getCityLsit(id)
              }
            }

            console.log('获取项目基础信息getProjectInfo', res, this.entity)
          } else {
            this.loading = false
            this.$notify.error(res.Msg)
          }
        })
    },
    // 保存
    save(num) {
      console.log('获取保存的基础项目信息', this.entity)
      if (!this.entity.Name) {
        return this.$notify.error('请输入项目名称')
      }
      if (!this.entity.Province) {
        return this.$notify.error('请选择所在城市省份')
      }
      if (!this.entity.City) {
        return this.$notify.error('请选择所在城市市区')
      }

      let obj = JSON.parse(JSON.stringify(this.entity))

      this.loading = true
      this.$http
        .post('/Base_ProjectWork/Base_Project/UpdateData', obj)
        .then((res) => {
          console.log('获取保存结果', res)
          this.loading = false
          if (res.Success) {
            // this.getProjectInfo();
            // this.disabled = true;
            this.$emit('infoFormClose', true)

            this.$notify.success('保存成功')
            window.localStorage.setItem('ProjectName', this.entity.Name)
            this.backName = this.entity.Name
            this.getProjectInfo()
            this.changeNum = 1
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
  },
  watch: {
    entity: {
      deep: true,
      handler() {
        this.changeNum++
      },
    },
  },
}
</script>

<style lang="scss" scoped>
// 取消input的上下箭头
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
}

::v-deep .el-form-item {
  margin-bottom: 10px;
}
::v-deep .Describe {
  height: auto;
}

::v-deep .el-textarea__inner {
  font-family: Arial;
}

.flex {
  display: flex;
}

.flex1 {
  flex: 1;
}

.infoBox {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 10px;
  padding-top: 0;
  .projectImg {
    width: 100%;
    height: 280px;

    .image-slot {
      text-align: center;
      line-height: 280px;
    }
  }

  .divContent {
    background: #fff;
    padding: 0 10px;
    border-radius: 3px;
    width: 100%;
    min-height: 40px;
    box-sizing: border-box;
    box-shadow: 1px 1px 5px #ccc;
    display: flex;
    justify-content: space-between;
    line-height: 2;
    align-items: center;

    .color {
      color: #c0c4cc;
    }
  }
}

::v-deep .avatar-uploader .el-upload {
  width: 100%;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  background-color: white;
  width: 280px;
  height: 280px;
  line-height: 280px;
  text-align: center;
}

.avatar {
  width: 280px;
  height: 280px;
  display: block;
}
</style>
